import { render, staticRenderFns } from "./channelsMapping.vue?vue&type=template&id=131e43cc&"
import script from "./channelsMapping.vue?vue&type=script&lang=js&"
export * from "./channelsMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports